module.exports = __webpack_public_path__ + "img/10.b235f689.webp";